import { useState } from "react";
import { Dialog } from "../ui/Dialog.js";
import { attachNeckDiagram } from "./api.js";
import { useNeckDiagramLibrary } from "./useNeckDiagramLibrary.js";

export function NeckDiagramLibraryPicker({ ensureLesson, onAdded, onClose }: {
  ensureLesson: () => Promise<string | null>; onAdded: (lessonId: string) => void; onClose: () => void;
}) {
  const library = useNeckDiagramLibrary();
  const [busy, setBusy] = useState(false), [problem, setProblem] = useState<string | null>(null);
  async function attach(id: string) {
    setBusy(true); setProblem(null);
    try {
      const lessonId = await ensureLesson();
      if (!lessonId) throw new Error("The lesson draft could not be saved. Try again.");
      await attachNeckDiagram(lessonId, id);
      onAdded(lessonId); onClose();
    } catch (error) { setProblem(error instanceof Error ? error.message : "Could not attach this sheet."); }
    finally { setBusy(false); }
  }
  return <Dialog title="Choose saved neck diagram" description="Attach a snapshot from My diagrams. Later edits to the original leave this lesson unchanged." busy={busy} onClose={onClose}>
    <label>Search My diagrams<input type="search" value={library.search} disabled={busy} onChange={event => library.setSearch(event.target.value)} /></label>
    {(library.error || problem) && <p className="error" role="alert">{library.error || problem}</p>}
    {library.error && <button type="button" onClick={library.reload}>Try again</button>}
    {library.loading && <p role="status">Loading diagrams…</p>}
    {!library.loading && !library.error && library.diagrams.length === 0 && <p>No saved sheets match. Create a new sheet from the lesson first.</p>}
    <ul className="neck-library-list">{library.diagrams.map(sheet => <li key={sheet.id}><button type="button" disabled={busy} onClick={() => void attach(sheet.id)}>Attach “{sheet.title}”</button></li>)}</ul>
    {library.nextOffset !== null && <button type="button" disabled={busy || library.loading} onClick={library.loadMore}>Load more diagrams</button>}
  </Dialog>;
}
